import { render } from "./NullableColumn.vue?vue&type=template&id=51ceb3ce"
import script from "./NullableColumn.vue?vue&type=script&lang=js"
export * from "./NullableColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__